import { useParams, Link } from "react-router-dom";
import "./project.css";

const projectsData = [
  {
    id: 1,
    title: "Secure Website",
    details:
      "project talk about adding tools security google authentication , and dos and sql injaction with know using mongodb.",
      features: [
        "Google Authentication: Users can securely log in using their Google accounts.",
        "DOS Protection: Implemented measures to prevent Denial of Service attacks.",
        "SQL Injection Prevention: Used parameterized queries to protect against SQL injection attacks.",
      ],
      Myrole:[
        "Implemented Google Authentication using OAuth 2.0.",
        "Designed and implemented security measures to protect against DOS attacks.",
        "Implemented SQL injection prevention techniques in the backend.",
      ],
    tech: ["React", "Node.js", "Tailwind CSS","Mongodb"],
    images: ["login.jpeg", "register.jpeg", "order1.jpeg", "dashboard.jpeg"],
  },
  {
    id: 2,
    title: "Restaurant Management System",
    details:
      "This project was developed to manage their menus,orders, and services efficiently through a web-based dashboard.",
      features: [
        "Order Management: View,and track customer orders .",
        "Menu Management: menu items with images and descriptions.",
      ],
      Myrole:["Designed and implemented the dashboard UI.", ],
    tech: ["React", "Tailwind CSS"],
    images: ["home.png", "service.jpeg", "order.jpeg", "menu.jpeg"],
  },
  {
    id: 3,
    title: "Menu Management System",
    details:
      "Project for Our Menu Collection to show details to meals,you will button to show many meals foods ,you can show it on youtube how cook it and Light & Dark Modes as feature  .",
    features: [
      "Menu Collection: Display a collection of meals with details.",
      "Meal Details: Show detailed information about each meal.",
      "YouTube Integration: Watch cooking tutorials on YouTube.",
      "Light & Dark Modes: Toggle between light and dark themes.",
    ],
    Myrole: [
      "Developed the menu collection interface.",
      "Implemented meal details display.",
      "Integrated YouTube videos for cooking tutorials.",
      "Added light and dark mode functionality.",
    ],
    tech: ["Javascript", "HTML", "CSS", "Bootstrap"],
    URL: "https://mazenbrkat.github.io/Meal-Recipe-App/",
    images: ["Menu Collections.png", "Details.png", "More Details.png", "Darkmode.png"],
  },
  {
    id: 4,
    title: "Cook & Learn – Full Stack Recipe Platform",
    details:
      "Cook & Learn is a full stack recipe platform that allows users to create and discover recipes. It features user authentication, recipe management, and interactive features such as comments and ratings.",
    features: [
      "Recipe browsing with search and filtering",
      "Add/remove favorites with real-time updates",
      "User authentication via Google OAuth",
      "Profile management with image upload",
      "Comments and ratings system",
      "Admin dashboard for managing recipes and users",
      "Responsive UI with modern design",
      "RESTful API integration with Node.js and MongoDB",
    ],
    Myrole: [
       "Developed a full-stack cooking web application using React.js and Node.js.",
       "Built responsive and user-friendly interfaces for browsing recipes.",
       "Added Google OAuth authentication for secure login.",
       "Created features like favorites, search, and filtering.",
    ],
    tech: ["React", "Node.js", "Express", "MongoDB", "Bootstrap"],
    images: ["cooklearn1.png", "cooklearn2.png", "cooklearn3.png", "cooklearn4.png","cooklearn5.png","cooklearn6.png"],
  }
];

const ProjectDetails = () => {
  const { id } = useParams();
  const project = projectsData.find(p => p.id === Number(id));

  if (!project) return <p>Project not found</p>;

  return (
    <section className="project-details-page">
      <div className="projects-container">

        <Link to="/" className="back-btn">← Back</Link>

        <h2>{project.title}</h2>
        <p className="details-text">{project.details}</p>
            <h3>Key features include:</h3>
        <ul className="features-list">
          {project.features && project.features.map((f, i) => (
            <li key={i}>{f}</li>
          ))}
        </ul>
          <h3>Technologies used:</h3>
        <div className="tech-list">
          {project?.tech?.map((t, i) => (
            <span key={i}>{t}</span>
          ))}
        </div>

            <h3>My role in this project:</h3>
        <ul className="role-list">
          {project.Myrole && project.Myrole.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>

        {project.URL && (
          <div style={{ margin: "20px 0" }}>
            <a 
              href={project.URL} 
              target="_blank" 
              rel="noopener noreferrer"
              className="details-btn"
              style={{ textDecoration: "none", display: "inline-block" }}
            >
              View Live Project
            </a>
          </div>
        )}

        <div className="details-gallery">
          {project.images.map((img, i) => (
            <img key={i} src={`${process.env.PUBLIC_URL}/${img}`} alt="Project" />
          ))}
        </div>

      </div>
    </section>
  );
};

export default ProjectDetails;